import React, { Component, Fragment } from "react";
import axios from "axios";

import constants from "../../constants";
import DataHandler from "./DataHandler";

import BarTitle from "../../components/BarTitle";
import Painel from "../../components/Painel/index";
import Bookings from "../../components/Bookings";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router";

import './styles.css'

class Users extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tableData: [],
      searchInputResult: "",
      searchResult: null,
      loadingSearch: false
    };

    this.setInputFilter = this.setInputFilter.bind(this);
    this.setFilter = this.setFilter.bind(this);
  }

  async setInputFilter(e) {

      // if (e.target.value.length > 0) {
        let result = e.target.value;

        this.setState({ searchInputResult: result });
  }

  async setFilter(e) {

    // if (e.target.value.length > 0) {
      let result = await this.dataFilter(this.state.tableData, this.state.searchInputResult);

      this.setState({ searchResult: result.result });

      if(result.result.length === 0) {
        this.setState({ loadingSearch: true })

      }else{
        this.setState({ loadingSearch: false })
      }
    // } else {
    //   this.setState({ searchResult: null });
    //   this.setState({ loadingSearch: false })
    // }
 
}

  async dataFilter(data, value) {
    let searched = value.toLowerCase()
    let result = [];
    const url = constants().URL_SERVICE + "account/manager/filter_client_users/?query=" + searched ;
    result = await axios.get(url, { headers: { Authorization: "Token " + localStorage.token } }).then(response => {
      
      // if(response.data.msg !== ""){
      //   toast.error(response.data.msg,{
      //     position: "top-right",
      //     autoClose: 1000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true, 
      //     draggable: true,
      //   })
      // }
      return response.data
      // this.setState({ tableData: response.data.list });
    })
    .catch(error => {
        console.error("ERRO +> ", error);
        // this.setState({ error: true })
        // toast.error("Ocorreu um Erro",{
        //   position: "top-right",
        //   autoClose: 3000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        // })
        return []
      }
    );
    // data.forEach(dataItem => {
    //   Object.keys(dataItem).some(key => {
    //     let valueString = dataItem[key].toString().toLowerCase();
    //     if (valueString.includes(searched)) {
    //       result = result.concat(dataItem);
    //       return true;
    //     }
    //   });
    // });

    return result;
  }

  filterData(data, filter) {
    return data.filter(item => {
      return Object.keys(item).some(key =>
        item[key].toLowerCase().includes(filter.toLowerCase())
      );
    });
  }

  componentDidMount() {
    const url = constants().URL_SERVICE + "account/manager/list_client_users/";

    axios
      .get(url, { headers: { Authorization: "Token " + localStorage.token } })
      .then(response => {
        this.setState({ tableData: response.data.client_users });
      })
      .catch(error => this.setState({ error: true }));
  }

  render() {
    const data = this.state.tableData;
    const filter = this.state.filter;
    const tableData = !filter ? data : this.filterData(data, filter);

    return (
      <div>
        <BarTitle name="Clientes" />
        <div className="wrapper-md">
          <Painel title="Clientes">
            <div className="row">
              <div className="col-md-4">
                <div className="input-group panel">
                  <span style={{cursor: 'pointer'}} className="input-group-addon" id="filter-addon" onClick={this.setFilter}>
                    Buscar
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    aria-describedby="filter-addon"
                    onChange={this.setInputFilter} 
                  />
                </div>
              </div>
            </div>
            <div className="table-wrap">
              
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nome</th>
                    <th>Email</th>
                    <th>Telefone</th>
                    <th>CPF</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                 {this.state.loadingSearch ? (
                    <div className="title-container">
                      <p className="title">Nenhum resultado encontrado.</p>
                    </div>
                     
                  
                  ): (
                <tbody>
                      {this.state.searchResult
                    ? this.state.searchResult.map((solicition, i) => (
                        <tr>
                          <td> {solicition.id} </td>
                          <td>
                            {solicition.first_name} {solicition.last_name}
                          </td>
                          <td>{solicition.email}</td>
                          <td>{solicition.phone}</td>
                          <td>{solicition.cpf}</td>
                          <td>
                            <Link
                              type="button"
                              to={{
                                pathname:
                                  "home/makesolicitation/" + solicition.id,
                                state: solicition
                              }}
                              params={solicition}
                              className="btn btn-success"
                            >
                              Solicitação de pagamento
                            </Link>
                          </td>
                        </tr>
                      ))
                    : this.state.tableData.map((solicition, i) => (
                        <tr>
                          <td> {solicition.id} </td>
                          <td>
                            {solicition.first_name} {solicition.last_name}
                          </td>
                          <td>{solicition.email}</td>
                          <td>{solicition.phone}</td>
                          <td>{solicition.cpf}</td>
                          <td>
                            <Link
                              type="button"
                              to={{
                                pathname:
                                  "home/makesolicitation/" + solicition.id,
                                state: solicition
                              }}
                              params={solicition}
                              className="btn btn-success"
                            >
                              Solicitação de pagamento
                            </Link>
                          </td>
                        </tr>
                      ))}
                
                     </tbody>
                  )}
                  
              </table>
            </div>
          </Painel>
        </div>
      </div>
    );
  }
}

export default Users;



// WEBPACK FOOTER //
// ./src/views/Users/index.js